import { Box, Grid } from "@mui/material";
import React, { useContext } from "react";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import ProfileHeader from "./ProfileHeader"
import ChangePassword from "./ChangePassword"
import ProfileAddress from "./ProfileAddress";
import UserMobileField from "./UserMobileField";
import PaymentsField from "./PaymentsField";
import DiscordField from "./DiscordField";
import { selectCurrentUser, setUser as setUserAction } from "../../../features/auth/authSlice";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  borderRadius: 20
}));

const Profile = () => {
  const dispatch = useDispatch();
  const user= useSelector(selectCurrentUser);
  
  function updateUser(newUser) {
    dispatch(setUserAction(newUser));
  }

  return (
    <Box sx={{ display: "flex", justifyContent: "center", flexDirection: "column", width: "100%" }}>
      <h3
        style={{ width: '100%', margin: ' 0 0 0 0', color: 'var(--orange)' }}>
        My Profile
      </h3>
      <Grid
        container
        spacing={1}
        sx={{ marginTop: "10px" }}
      >
        {user !== null ?
          (<>
            <Grid item xs={12}>
              <Item>
                <ProfileHeader user={user} />
              </Item>
            </Grid>
            <Grid item xs={12}>
              <Item>
                <Box sx={{ padding: "1em", display: "flex", flexDirection: "column" }}>
                  <Box sx={{ display: "flex" }}>
                    <h4 className="item-profile-header">Personal Information</h4>
                  </Box>
                  <Box sx={{marginTop: "15px"}} >
                    <Box>
                      <ProfileAddress user={user} setUser={updateUser} />
                    </Box>

                    <div className="divisor" style={{ margin: "0.5em 0 1em 0" }}></div>

                    <Box>
                      <UserMobileField user={user} setUser={updateUser} />
                    </Box>
                  </Box>
                </Box>
              </Item>
            </Grid>
            <Grid item xs={12}>
              <Item>
                <Box sx={{ padding: "1em", display: "flex", flexDirection: "column" }}>
                  <Box sx={{ display: "flex" }}>
                    <h4 className="item-profile-header">Password Change</h4>
                  </Box>
                  <Box sx={{marginTop: "15px"}}>
                    <Box>
                      <ChangePassword/>
                    </Box>
                  </Box>
                </Box>
              </Item>
            </Grid>

            <Grid item xs={6}>
              <Item>
                <Box sx={{ padding: "1em", display: "flex", flexDirection: "column" }}>
                  <Box sx={{ display: "flex" }}>
                    <h4 className="item-profile-header">Discord</h4>
                  </Box>
                  <Box sx={{marginTop: "15px"}}>
                    <Box>
                      <DiscordField user={user} setUser={updateUser}/>
                    </Box>
                  </Box>
                </Box>
              </Item>
            </Grid>

            <Grid item xs={6}>
              <Item>
                <Box sx={{ padding: "1em", display: "flex", flexDirection: "column" }}>
                  <Box sx={{ display: "flex" }}>
                    <h4 className="item-profile-header">Payments</h4>
                  </Box>
                  <Box sx={{marginTop: "15px"}}>
                    <Box>
                      <PaymentsField user={user} setUser={updateUser}/>
                    </Box>
                  </Box>
                </Box>
              </Item>
            </Grid>
          </>)
          : null
        }

      </Grid>
    </Box>
  )
}

export default Profile;